import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import {Inc,Owner,Book,BookOption,Dataset} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    owner:Owner,
    book:Book,
    option:BookOption,
    update(option:BookOption):void,
    save():void,
}

const BookInputTab1 = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const classes = useStyles();
    const [states,setStates] = useState({
        book: Inc.defaultBook(),
        option: Inc.defaultBookOption(),
        toast:"",
        notFound: false,
        isLoading: false,
    });
    const changeChecks = (name: keyof BookOption,value: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        //console.log("checked",states.option.serifu_id,name,value,event.target.checked);
        let checks:number[] = [];
        if( event.target.checked ){
            checks.push(value);    
        }
        if( name==="serifu_id" ){
            for( let i=0 ; i<states.option.serifu_id.length; i++ ){
                if( states.option.serifu_id[i]!==value ){
                    checks.push(states.option.serifu_id[i]);
                }
            }
        }
        if( name==="conv_type_id" ){
            for( let i=0 ; i<states.option.conv_type_id.length; i++ ){
                if( states.option.conv_type_id[i]!==value ){
                    checks.push(states.option.conv_type_id[i]);
                }
            }
        }

        setStates({ ...states, option:{...states.option,[name]: checks}});
    }
    const changeCheck = (name: keyof BookOption) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = 0;
        if( event.target.checked ){
            value = 1;
        }
        setStates({ ...states, option:{...states.option,[name]: value}});
    }
    const changeSelect = (name: keyof BookOption) => (event: SelectChangeEvent) => {
        setStates({...states,option:{...states.option,[name]: parseInt(event.target.value as string)}});
    }
    const update = ()=>{
        props.update(states.option);
    }
    const save = ()=>{
        props.save();
    }
    //const send = ()=>{
    //    Ajax.send("book/updated",{
    //        item_id:props.book.item_id,
    //        option:states.option,
    //    },(res:any)=>{
    //        if( res.ok ){
    //            //props.change({...states.book,img_id:res.img_id},states.option);
    //        } else {
    //            setStates({...states,toast:"エラー"});
    //        }
    //    });
    //}
    //const closeToast = ()=>{
    //    setStates({...states,toast:""});
	//}

    useEffect( ()=>{
        setStates({ ...states, option:props.option});
    },[]);


    if(states.isLoading){
        return (
            <Loading isLoading={true}/>
        )
    }

    return (
        <div id="book_input_tab1">
            <div id="tab1" className="bookTab">
                <Grid container spacing={2} style={{marginBottom:"2em"}}>
                    <Grid item xs={8}>
                        <Button variant="outlined" color="primary" onClick={update} style={{width:"100%"}}>以下の条件で一括処理する</Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" color="primary" style={{width:"100%"}} onClick={save}>保存する</Button>
                    </Grid>
                </Grid>
                <div className="bookChecks">
                    <h3>セリフ</h3>
                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">次の条件のいずれかを満たせばセリフ</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <React.Fragment>
                                    <Checkbox checked={states.option.serifu_id.includes(1)} color="primary" onChange={changeChecks('serifu_id',1)} value="1" className="checkbox"/>
                                    <span style={{fontSize:"90%",marginRight:"1em"}}>役名の後に</span>
                                    <Select value={states.option.serifu_chara_id!==0 ? String(states.option.serifu_chara_id):'1'} onChange={changeSelect('serifu_chara_id')} classes={{nativeInput:"selectRoot",select:"selectSelect"}}>
                                        {Inc.bookSerifuCharas.map( (data:Dataset,index:number)=>{
                                            const key = "serifu_chara"+index;
                                            return (
                                                <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
                                            )
                                        })}
                                    </Select>

                                    </React.Fragment>
                                }
                                label=""
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.serifu_id.includes(2)} color="primary" onChange={changeChecks('serifu_id',2)} value="2" className="checkbox"/>
                                }
                                label="言葉を全角「」で囲っている"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.serifu_id.includes(5)} color="primary" onChange={changeChecks('serifu_id',5)} value="5" className="checkbox"/>
                                }
                                label={(<React.Fragment>言葉を全角｛｝で囲っている <span style={{color:"#999999",fontSize:"90%"}}>｛｝は非表示</span></React.Fragment>)}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.serifu_id.includes(3)} color="primary" onChange={changeChecks('serifu_id',3)} value="3" className="checkbox"/>
                                }
                                label="先頭10字以内に全角空白が1つ以上入っている"
                            />
                        </FormGroup>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">オプション（必要に応じてチェック）</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.serifu_opt1===1} color="primary" onChange={changeCheck('serifu_opt1')} value="1" className="checkbox"/>
                                }
                                label="セリフ途中の改行あり"
                            />
                            <div className="book_input_hint">
                                ※次の行が他のセリフ・空白行・見出しでなければ続きとみなす<br/>
                                ※カッコで囲っているセリフにはこの設定は不要<br/>
                            </div>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.serifu_opt2===1} color="primary" onChange={changeCheck('serifu_opt2')} value="1" className="checkbox"/>
                                }
                                label="自動インデントを無効にする"
                            />
                            <div className="book_input_hint">
                                ※行頭の全角空白を自動削除されたくない場合はチェック<br/>
                            </div>
                        </FormGroup>
                    </FormControl>

                </div>
                <div className="bookChecks">
                    <h3>見出し</h3>
                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">次の条件を満たせば見出し（大）</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <React.Fragment>
                                    <Checkbox checked={states.option.midashi1_id===1} color="primary" onChange={changeCheck('midashi1_id')} value="1" className="checkbox"/>
                                    <span style={{fontSize:"90%",marginRight:"1em"}}>先頭の文字が</span>
                                    <Select value={states.option.midashi1_chara_id!==0 ? String(states.option.midashi1_chara_id) : '1'} onChange={changeSelect('midashi1_chara_id')} classes={{nativeInput:"selectRoot",select:"selectSelect"}}>
                                        {Inc.bookMidashiCharas.map( (data:Dataset,index:number)=>{
                                            const key = "midashi1_chara"+index;
                                            return (
                                                <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                    </React.Fragment>
                                }
                                label=""
                            />
                            {states.option.midashi1_id===1 &&
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.midashi1_opt1===1} color="primary" onChange={changeCheck('midashi1_opt1')} value="1" className="checkbox"/>
                                }
                                label="先頭の文字を削除する"
                            />
                            }
                        </FormGroup>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">次の条件を満たせば見出し（小）</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <React.Fragment>
                                    <Checkbox checked={states.option.midashi2_id===1} color="primary" onChange={changeCheck('midashi2_id')} value="1" className="checkbox"/>
                                    <span style={{fontSize:"90%",marginRight:"1em"}}>先頭の文字が</span>
                                    <Select value={states.option.midashi2_chara_id!==0 ? String(states.option.midashi2_chara_id):'1'} onChange={changeSelect('midashi2_chara_id')} classes={{nativeInput:"selectRoot",select:"selectSelect"}}>
                                        {Inc.bookMidashiCharas.map( (data:Dataset,index:number)=>{
                                            const key = "midashi2_chara"+index;
                                            return (
                                                <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                    </React.Fragment>
                                }
                                label=""
                            />
                            {states.option.midashi2_id===1 &&
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.midashi2_opt1===1} color="primary" onChange={changeCheck('midashi2_opt1')} value="1" className="checkbox"/>
                                }
                                label="先頭の文字を削除する"
                            />
                            }
                        </FormGroup>
                    </FormControl>

                </div>
                <div className="bookChecks">
                    <h3>その他</h3>
                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">文字を一括変換する</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.conv_type_id.includes(1)} color="primary" onChange={changeChecks('conv_type_id',1)} value="1" className="checkbox"/>
                                }
                                label="半角数字を全角に変換する"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.conv_type_id.includes(2)} color="primary" onChange={changeChecks('conv_type_id',2)} value="2" className="checkbox"/>
                                }
                                label="半角英字を全角に変換する"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.conv_type_id.includes(3)} color="primary" onChange={changeChecks('conv_type_id',3)} value="3" className="checkbox"/>
                                }
                                label="半角カナを全角に変換する"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.conv_type_id.includes(4)} color="primary" onChange={changeChecks('conv_type_id',4)} value="4" className="checkbox"/>
                                }
                                label="半角カッコを全角に変換する"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.conv_type_id.includes(11)} color="primary" onChange={changeChecks('conv_type_id',11)} value="11" className="checkbox"/>
                                }
                                label="英数字と記号だけの行は横文字で表示する"
                            />
                        </FormGroup>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <FormLabel className="formLabel">フォント</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.font_opt1===1} color="primary" onChange={changeCheck('font_opt1')} value="1" className="checkbox"/>
                                }
                                label="セリフ先頭の人名をゴシックで表示"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={states.option.font_opt2===1} color="primary" onChange={changeCheck('font_opt2')} value="1" className="checkbox"/>
                                }
                                label="ト書きをゴシックで表示"
                            />
                        </FormGroup>
                    </FormControl>
                </div>
            </div>
        </div>
	);
}

export default BookInputTab1;
